import React from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { FiExternalLink, FiFileText } from "react-icons/fi";
import { StatusBadge } from "../dashboard/DashboardUI";
import { requestTitle } from "../../utils/requestDisplay";
import { detailsFor } from "../../utils/requestDetails";
import "../dashboard/dashboard.css";

const STEPS = [
  { status: "paid", label: "Payée" },
  { status: "in_progress", label: "En cours" },
  { status: "fulfilled", label: "Terminée" },
];

export function RequestSteps({ status }) {
  const current = STEPS.findIndex((step) => step.status === status);
  if (current === -1) return null;

  return (
    <ol className="dash-steps" aria-label="Avancement">
      {STEPS.map((step, index) => (
        <li
          key={step.status}
          className={index <= current ? "is-done" : ""}
          aria-current={index === current ? "step" : undefined}
        >
          {step.label}
        </li>
      ))}
    </ol>
  );
}

export function DocumentList({ documents }) {
  if (!documents.length) return null;

  return (
    <>
      <h3 className="dash-subtitle">Documents</h3>
      <ul className="dash-list">
        {documents.map(({ key, label, file }) => (
          <li key={key}>
            <div className="dash-file-row">
              <FiFileText aria-hidden="true" />
              <div>
                <span className="dash-cell-title">{label}</span>
                {file.name && (
                  <span className="dash-cell-sub">{file.name}</span>
                )}
              </div>
            </div>
            <a
              className="dash-link-button"
              href={file.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              Voir <FiExternalLink aria-hidden="true" />
            </a>
          </li>
        ))}
      </ul>
    </>
  );
}

// Detail window shared by every type of request
function RequestDetailModal({ show, onHide, procedure }) {
  if (!procedure) return null;

  const { rows, documents } = detailsFor(procedure);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <div className="dash-modal-head">
          <Modal.Title as="h2" className="dash-card-title mb-0">
            {requestTitle(procedure)}
          </Modal.Title>
          <span className="dash-cell-sub">
            #{procedure.reference} ·{" "}
            {moment(procedure.createdAt).format("DD/MM/YYYY")}
          </span>
        </div>
        <StatusBadge status={procedure.status} />
      </Modal.Header>

      <Modal.Body>
        <RequestSteps status={procedure.status} />

        {rows.length > 0 && (
          <dl className="dash-details">
            {rows.map(([label, value]) => (
              <React.Fragment key={label}>
                <dt>{label}</dt>
                <dd className="dash-pre">{value}</dd>
              </React.Fragment>
            ))}
          </dl>
        )}

        <DocumentList documents={documents} />

        {procedure.comment && (
          <div className="dash-note">
            <h3 className="dash-subtitle">Message de nos équipes</h3>
            <p className="dash-pre">{procedure.comment}</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default RequestDetailModal;
